import React, { useContext, useEffect, useState } from "react";
import { Button, Spinner } from "grommet";
import ContactFormModal from "../LearningPaths/ContactFormModal";
import { Box, Heading, Text, Layer } from "grommet";
import axios from "axios";
import API_URL from "../../config/config";
import { getUserName } from "../../services/dashboardService";
import { AuthContext } from "../../contexts/AuthContext";

export const DedicatedLearningButton = ({ user_id }) => {
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);

  const { user } = useContext(AuthContext);
  const handleCloseModal = () => setShowModal(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [userCountry, setUserCountry] = useState("");
  const [popup, setPopup] = useState({
    message: "",
    status: "",
    visible: false,
  });

  const fetchUserData = async () => {
    try {
      axios.get(`${API_URL}/user/getUser/${user_id}`).then((response) => {
        setUserCountry(response.data.user.country);
      });
    } catch (error) {
      console.error("Error loading dashboard data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchData = async () => {
    try {
      console.log("user_id", user_id);
      const name = localStorage.getItem("userName")
        ? localStorage.getItem("userName")
        : await getUserName(user_id);
      console.log("name", name);
      setUserName(name);
    } catch (error) {
      console.error("Error loading dashboard data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleFormSubmit = async (formData) => {
    setIsLoading(true);
    formData = { ...formData, user_id: user_id };

    try {
      await axios.post(
        `${API_URL}/dashboard/request-dedicated-learning`,
        formData,
      );
      setShowModal(false);
      setIsLoading(false);
      setPopup({
        message:
          "Thanks for contacting HPE Education Services. One of our friendly staff will get in touch with you shortly. If the request is urgent, please contact your local HPE Education Services office",
        status: "normal",
        visible: true,
      });
    } catch (error) {
      console.error("Error submitting the form:", error);
      setIsLoading(false);
      setPopup({
        message:
          "There was an error processing your request. Please try again.",
        status: "critical",
        visible: true,
      });
    }
  };
  if (isLoading) {
    return <Spinner />;
  }
  return (
    <Box>
      <Button
        label="To request customised/dedicated learning experience click here"
        onClick={handleOpenModal}
        primary
      />
      {showModal && (
        <ContactFormModal
          username={userName}
          email={user.email}
          country={userCountry}
          onClose={handleCloseModal}
          onSubmit={handleFormSubmit}
        />
      )}
      {popup.visible && (
        <Layer
          onEsc={() => setPopup({ ...popup, visible: false })}
          onClickOutside={() => setPopup({ ...popup, visible: false })}
        >
          <Box pad="medium" gap="small" width="medium">
            <Heading level={3} margin="none">
              {popup.status === "normal" ? "Success" : "Error"}
            </Heading>
            <Text>{popup.message}</Text>
            <Box direction="row" gap="medium" justify="end">
              <Button
                label="Close"
                onClick={() => setPopup({ ...popup, visible: false })}
                primary
              />
            </Box>
          </Box>
        </Layer>
      )}
    </Box>
  );
};
